<script lang="ts">
const __DsBlock = {
	type: 'display',
	category: 'display',
	hidden: true,

	fieldBinding: {
		supportedTypes: ['text'],
	},
}
</script>
<script setup lang="ts">
import type { DisplayBlockProps } from '#layers/blocks/types/display-block';
import { computed } from 'vue';
import { useUserLocale } from '#layers/base/public';
import { defineBlock } from '#layers/block-engine/public';
import { useFormattedDisplayValue } from '#layers/blocks/composables/use-formatted-display-value';
import { ADMIN_ROLE_ID, PUBLIC_ROLE_ID } from '#layers/data-model/public';
import { useTranslationUtils } from '#layers/i18n/public';

// TODO: Drop this block once displays support filter-driven optional formatting. The role listing
// could then render the shared value display and attach protected-role icons through conditions on
// their fixed ids, instead of a role-specific display block.

interface RoleNameItem {
	id?: string;
}

interface DisplayRoleNameBlockProps extends DisplayBlockProps<string, RoleNameItem> {}

const { value, item } = defineProps<DisplayRoleNameBlockProps>();

;

const { translateString } = useTranslationUtils();
const { language } = useUserLocale();

// Role names are user-authored, so they render verbatim; protected roles arrive as `$t:`
// placeholders, which `translateString` resolves.
const content = useFormattedDisplayValue({
	value: () => value,
	convertToTitleCase: () => false,
	language,
	translateString,
});

const isPublicRole = computed(() => item?.id === PUBLIC_ROLE_ID);
const isAdminRole = computed(() => item?.id === ADMIN_ROLE_ID);
</script>

<template>
	<div class="flex min-w-0 items-center gap-2">
		<DTooltip v-if="isPublicRole" :text="$t('pages.settings.access.pages.roles.public_role_hint')">
			<DIcon name="lucide:globe" class="size-4 shrink-0 text-primary" />
		</DTooltip>
		<DTooltip v-else-if="isAdminRole" :text="$t('common.admin_role')">
			<DIcon name="lucide:shield-check" class="size-4 shrink-0 text-orange-500 dark:text-orange-400" />
		</DTooltip>

		<span class="truncate">{{ content }}</span>
	</div>
</template>
